import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PopularArtists = ({ artists = [] }) => {
  const navigate = useNavigate();

  const handleViewArtist = (artistId) => {
    navigate(`/artist-detail-editor-view?id=${artistId}`);
  };

  const getRankingColor = (rank) => {
    if (rank === 1) return 'text-yellow-600';
    if (rank === 2) return 'text-gray-500';
    if (rank === 3) return 'text-orange-600';
    return 'text-text-secondary';
  };

  const getRankingIcon = (rank) => {
    if (rank <= 3) return 'Crown';
    return 'TrendingUp';
  };

  return (
    <div className="bg-card border border-border rounded-lg elevation-1">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-text-primary">Popular Artists</h3>
          <Button variant="ghost" size="sm" iconName="BarChart3" />
        </div>
        <p className="text-sm text-text-secondary mt-1">
          Top performing artists this month
        </p>
      </div>
      <div className="p-4">
        {artists?.length === 0 ? (
          <div className="text-center py-6">
            <Icon name="TrendingUp" size={32} className="text-text-secondary mx-auto mb-2" />
            <p className="text-sm text-text-secondary">No data available</p>
          </div>
        ) : (
          <div className="space-y-3">
            {artists?.map((artist, index) => {
              const rank = index + 1;
              return (
                <div
                  key={artist?.id}
                  className="flex items-center space-x-3 p-2 rounded-lg hover:bg-muted transition-smooth cursor-pointer"
                  onClick={() => handleViewArtist(artist?.id)}
                >
                  <div className="flex items-center justify-center w-8 h-8">
                    <div className="flex items-center space-x-1">
                      <Icon 
                        name={getRankingIcon(rank)} 
                        size={14} 
                        className={getRankingColor(rank)} 
                      />
                      <span className={`text-sm font-bold ${getRankingColor(rank)}`}>
                        {rank}
                      </span>
                    </div>
                  </div>
                  <div className="relative">
                    <Image
                      src={artist?.avatar}
                      alt={artist?.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    {rank <= 3 && (
                      <div className="absolute -top-1 -right-1 w-4 h-4 bg-accent rounded-full flex items-center justify-center">
                        <Icon name="Star" size={8} className="text-white" />
                      </div>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-text-primary truncate">
                      {artist?.name}
                    </p>
                    <div className="flex items-center space-x-2 text-xs text-text-secondary">
                      <span>{artist?.views} views</span>
                      <span>•</span>
                      <div className="flex items-center space-x-1">
                        <Icon 
                          name={artist?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                          size={10} 
                          className={artist?.trend === 'up' ? 'text-success' : 'text-destructive'}
                        />
                        <span className={artist?.trend === 'up' ? 'text-success' : 'text-destructive'}>
                          {artist?.change}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-medium text-text-primary">
                      {artist?.score}
                    </p>
                    <p className="text-xs text-text-secondary">score</p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        
        {artists?.length > 0 && (
          <div className="mt-4 pt-3 border-t border-border">
            <Button
              variant="ghost"
              size="sm"
              fullWidth
              iconName="ArrowRight"
              iconPosition="right"
            >
              View Full Rankings
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopularArtists;